export default __webpack_public_path__ + "static/media/angular.b91d4b54.svg";